import { render } from "./GiManage.vue?vue&type=template&id=3fdda0d8"
import script from "./GiManage.vue?vue&type=script&lang=js"
export * from "./GiManage.vue?vue&type=script&lang=js"

import "./GiManage.vue?vue&type=style&index=0&id=3fdda0d8&lang=less"

import exportComponent from "D:\\VueProject\\everlife-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__